import screen from './List';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Segmentos/List/index.js